import Api from '@/common/api'
import { getUrl } from '@/common/helper'

export const authentication = {
  state: {
    lname: '',
    fname: '',
    lastLogin: '',
    token: '',
    status: '',
    l0: [],
    l1: [],
    l2: [],
    apr: false
  },
  actions: {
    login (context, payload) {
      return new Promise((resolve, reject) => {
        Api()
          .post(getUrl('core', 'authentication'), payload)
          .then(response => {
            let accessToken = response.data.token
            let accessfname = response.data.fname
            let accesslname = response.data.lname
            let accessLastLogin = response.data.ldate
            let accessmenus = JSON.stringify(response.data.l0)
            let accessmodules = JSON.stringify(response.data.l1)
            let accesscategories = JSON.stringify(response.data.l2)
            let accessapr = response.data.apr
            let accessInformation = response.data.inf

            context.commit('authSuccess', accessToken)
            context.commit('authUserLname', accesslname)
            context.commit('authUserFname', accessfname)
            context.commit('authLastLogin', accessLastLogin)
            context.commit('authMenus', accessmenus)
            context.commit('authModules', accessmodules)
            context.commit('authCategories', accesscategories)
            context.commit('authApr', accessapr)
            context.commit('authInformation', accessInformation)
            localStorage.setItem('uname', payload.Username)
            // Api().defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
            resolve(response)
          })
          .catch((error) => {
            delete Api().defaults.headers.common['Authorization']
            context.commit('authError')
            reject(error)
          })
      })
    },
    logout (context) {
      return new Promise((resolve, reject) => {
        delete Api().defaults.headers.common['Authorization']
        context.commit('authError')
        resolve()
      })
    }
  },
  mutations: {
    authSuccess (state, token) {
      state.token = token
      state.status = 'success'
      localStorage.setItem('token', token)
    },
    authError (state) {
      state.token = ''
      state.status = 'error'
      // state.username = ''
      localStorage.removeItem('token')
      localStorage.removeItem('fname')
      localStorage.removeItem('lname')
      localStorage.removeItem('lastLogin')
      localStorage.removeItem('l1')
      localStorage.removeItem('l2')
      localStorage.removeItem('l3')
      localStorage.removeItem('uname')
      localStorage.removeItem('apr')
      localStorage.removeItem('accessInformation')
    },
    authLogout (state) {
      state.token = ''
      localStorage.removeItem('token')
      localStorage.removeItem('fname')
      localStorage.removeItem('lname')
      localStorage.removeItem('lastLogin')
      localStorage.removeItem('l1')
      localStorage.removeItem('l2')
      localStorage.removeItem('l3')
      localStorage.removeItem('uname')
      localStorage.removeItem('apr')
      localStorage.removeItem('accessInformation')
    },
    authUserLname (state, lname) {
      state.lname = lname
      localStorage.setItem('lname', lname)
    },
    authUserFname (state, fname) {
      state.fname = fname
      localStorage.setItem('fname', fname)
    },
    authLastLogin (state, lastLogin) {
      state.lastLogin = lastLogin
      localStorage.setItem('lastLogin', lastLogin)
    },
    authMenus (state, menus) {
      state.l0 = menus
      localStorage.setItem('l0', menus)
    },
    authModules (state, modules) {
      state.l1 = modules
      localStorage.setItem('l1', modules)
    },
    authCategories (state, categories) {
      state.l2 = categories
      localStorage.setItem('l2', categories)
    },
    authApr (state, apr) {
      state.apr = apr
      localStorage.setItem('apr', apr)
    },
    authInformation (state, accessInformation) {
      state.accessInformation = accessInformation
      localStorage.setItem('accessInformation', accessInformation)
    }
  }
  // ,
  // getters: {
  //   authUsername: state => state.username,
  //   isAuthenticated: state => {
  //     return state.status === true && state.token !== ''
  //   }
  // }
}
